import { JobsUploadState } from '../../store/state';
import { UploadAction, UploadActions } from '../actions';

const initialState: JobsUploadState = {
  data: null,
  isLoading: false,
  isUploading: false,
  uploadErrors: null,
};

const jobsUploadsReducer = (state: JobsUploadState = initialState, action: UploadAction): JobsUploadState => {
  switch (action.type) {
    case UploadActions.UploadSuccess:
      return {
        ...state,
        data: [ ...state?.data || [], action.payload ],
      };
    case UploadActions.LoadUploads:
      return {
        ...state,
        isLoading: true,
      };
    case UploadActions.LoadUploadsSuccess:
      return {
        ...state,
        isLoading: false,
        data: action.payload,
      };
    case UploadActions.UploadRequest:
      return {
        ...state,
        isUploading: true,
        uploadErrors: null,
      };
    case UploadActions.UploadError:
      return {
        ...state,
        isUploading: false,
        uploadErrors: action.payload,
      };
    case UploadActions.ProcessUploadSuccess:
      return {
        ...state,
        data: [
          ...state.data.filter(item => item.id !== action.payload.id),
          action.payload,
        ],
      };
    default:
      return state;
  }
};

export default jobsUploadsReducer;